import { createContext, useContext, useState } from "react";
import { useGroupsQuery } from "../../App/Queries/GroupQueries";
import { IGroup } from "../../App/Typings/Groups";

interface GroupsContextValue {
  groups: IGroup[];
  groupsFetched: boolean;
  selectedGroupIds: string[];
  setSelectedGroupIds: (ids: string[]) => void;
}

const GroupsContext = createContext<GroupsContextValue | null>(null);

export function GroupsContextProvider({ children }: { children: React.ReactNode }) {
  const { data: groups, isFetched: groupsFetched } = useGroupsQuery(true);
  const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>([]);

  return (
    <GroupsContext.Provider
      value={{ groups: groups?.items ?? [], groupsFetched, selectedGroupIds, setSelectedGroupIds }}
    >
      {children}
    </GroupsContext.Provider>
  );
}

export const useGroupsContext = () => {
  const ctx = useContext(GroupsContext);
  if (!ctx) throw new Error("useGroupsContext must be inside GroupsContextProvider");
  return ctx;
};
